'use client'

import { parseAsString, useQueryState } from 'nuqs'

import { useOrders } from '@/lib/hooks/use-orders'

import { OrdersDatePicker, OrdersList, OrdersSearch } from '@/components/molecules'
import { OrdersPlaceholder } from '@/components/placeholders'
import { LoadingDots, ScrollArea } from '@/components/ui'

export const OrdersContent = () => {
  const [from] = useQueryState('from', parseAsString.withDefault(''))
  const [to] = useQueryState('to', parseAsString.withDefault(''))
  const [search] = useQueryState('search', parseAsString.withDefault(''))

  const {
    data: orders,
    isLoading,
    error,
  } = useOrders({
    from: from || undefined,
    to: to || undefined,
    search: search || undefined,
  })

  return (
    <div className="flex h-[calc(var(--inner-layout-height))] w-full flex-col gap-4 lg:pt-4">
      <div className="flex flex-col gap-3">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-medium">All Orders</h2>
          <span className="text-sm text-gray-700">
            {isLoading ? '...' : `Showing ${orders?.length ?? 0} orders`}
          </span>
        </div>

        <div className="flex items-center justify-end gap-2">
          <OrdersSearch />
          <OrdersDatePicker />
        </div>
      </div>

      <ScrollArea className="flex h-full w-full flex-col gap-12">
        {isLoading && (
          <div className="flex h-full w-full items-center justify-center">
            <LoadingDots />
          </div>
        )}

        {error && (
          <div className="flex h-full w-full items-center justify-center">
            <p className="text-sm text-red-600">
              Failed to load orders. Please try again.
            </p>
          </div>
        )}

        {!isLoading && !error && orders?.length === 0 && (
          <OrdersPlaceholder
            title="No orders"
            description="Your orders will appear here."
          />
        )}
        {!isLoading && !error && orders?.length !== 0 && (
          <OrdersList data={orders ?? []} />
        )}
      </ScrollArea>
    </div>
  )
}
